import { ORIENTATIONS } from "../../constants";

export default props => {
  const { center, left, right } = props;
  if (center) {
    return ORIENTATIONS.CENTER;
  } else if (left) {
    return ORIENTATIONS.LEFT;
  } else if (right) {
    return ORIENTATIONS.RIGHT;
  }
  return ORIENTATIONS.LEFT;
};
